
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import DialogOrBottomSheet from '@/components/base/DialogOrBottomSheet.vue';
import DialogContent from '@/components/base/DialogContent.vue';
import ActionsIsland from '@/components/ActionsIsland.vue';
import NumberField from '@/components/base/NumberField.vue';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { functions } from '@/firebase';
import { tokensToHundredths } from '@run-diffusion/shared';
import { DEFAULT_TEXT_MAX_LENGTH, getShowTextCounterAt, getTextMaxLengthRule } from '@/utils';

export default Vue.extend({
	name: 'NewRecordForCompanyBankBtn',
	data () {
		return {
			showDialog: false,
			loading: false,
			formValid: true,
			tokens: null,
			isCredit: true,
			note: '',
			DEFAULT_TEXT_MAX_LENGTH,
			rules: {
				tokens: [
					v => !!v || 'Tokens is required',
					v => v > 0 || 'Tokens must be greater than 0',
				],
				note: [
					getTextMaxLengthRule(DEFAULT_TEXT_MAX_LENGTH),
					v => !!v || 'Note is required',
				],
			},
		};
	},
	computed: {
		...mapState([
			'team',
		]),
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		getShowTextCounterAt,
		onShowDialogInput (val: boolean) {
			this.showDialog = !!val;
			if (!val) {
				this.resetValues();
			}
		},
		handleNewRecordClick () {
			this.showDialog = true;
		},
		resetValues () {
			this.tokens = null;
			this.isCredit = true;
			this.note = '';
		},
		async handleSubmit () {
			if (!this.$refs.form.validate()) {
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: 'Form invalid, check fields',
					show: true,
				});
				return;
			}

			if (!this.team?.companyId) {
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: 'Company ID not found',
					show: true,
				});
				return;
			}

			this.loading = true;

			try {
				const functionRef = functions.httpsCallable('createCompanyBalanceRecord');
				const { success, message } = (await functionRef({
					companyId: this.team.companyId,
					tokens: tokensToHundredths(this.tokens),
					isCredit: this.isCredit,
					note: this.note,
				})).data;

				if (success) {
					this.updateSnackbar({
						status: SNACKBAR_STATUS.SUCCESS,
						message: message || 'New record created successfully!',
						show: true,
					});

					// Reset form to clear validation errors
					this.$refs.form.reset();

					this.showDialog = false;
					this.resetValues();

					// Emit event to trigger history refresh
					this.$emit('record-created');
				} else {
					this.updateSnackbar({
						status: SNACKBAR_STATUS.ERROR,
						message: message || 'Failed to create record',
						show: true,
					});
				}
			} catch (e) {
				console.error(e);
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: 'An error occurred while creating the record',
					show: true,
				});
			} finally {
				this.loading = false;
			}
		},
	},
	components: {
		DialogOrBottomSheet,
		DialogContent,
		ActionsIsland,
		NumberField,
	},
});
